export default {
      id: "bottom-shape-usage",
      viewBox: "0 0 1920 224",
      url: "../../assets/" + "sprite.svg#bottom-shape-usage",
      toString: function () {
        return this.url;
      }
    }